import { ChangeDetectionStrategy, Component, input, computed } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HomeContentMappedProductList } from 'src/app/home/models/home-content.model';
import { Banner, ClickActionChoices } from 'src/app/home/models/home.model';
import { HorizontalBannerListComponent } from "../horizontal-banner-list/horizontal-banner-list.component";
import { BannerVariantComponent } from "./banner-variant/banner-variant.component";

@Component({
  standalone: true,
  selector: 'banner-layouts',
  templateUrl: './banner-layouts.component.html',
  styleUrls: ['./banner-layouts.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, HorizontalBannerListComponent, BannerVariantComponent]
})
export class BannerLayoutsComponent {

  readonly home_content_section = input<HomeContentMappedProductList>({} as HomeContentMappedProductList);

  readonly banners = computed(() => this.populateBanners(this.home_content_section()));
  readonly layout = computed(() => this.home_content_section()?.layout ?? 1);
  readonly class = computed(() => this.getClassForLayout(this.layout()) || '');

  ClickActionChoices = ClickActionChoices;

  private getClassForLayout(layout: number) {

    switch (layout) {
      case 1:
        return 'col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 mb-4 mb-sm-4 mb-md-4 mb-lg-4 mb-xl-4';
        break;
      case 2:
        return 'col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 mb-4 mb-sm-4 mb-md-4 mb-lg-4 mb-xl-4';
        break;
      case 3:
        return 'col-12 col-sm-12 col-md-6 col-lg-4 col-xl-4 mb-4 mb-sm-4 mb-md-4 mb-lg-4 mb-xl-4'
        break;
      case 4:
        return 'col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 mb-4 mb-sm-4 mb-md-4 mb-lg-4 mb-xl-4'
        break;
      case 6:
        return 'col-12 col-sm-12 col-md-6 col-lg-4 col-xl-4 mb-4 mb-sm-4 mb-md-4 mb-lg-4 mb-xl-4'
        break;
      case 9:
        return 'col-12 col-sm-12 col-md-6 col-lg-4 col-xl-4 mb-4 mb-sm-4 mb-md-4 mb-lg-4 mb-xl-4'
        break;
      default:
        break;
    }

  }

  private populateBanners(homeContentSection: HomeContentMappedProductList): Banner[] {
    const { banner_sections } = homeContentSection;
    // active filter;
    /* const banners = [...Array(layout).keys()].map(position => {

      const banner = banner_sections.find(banner => banner.position === position);

      return banner ?? ({} as Banner);
    }); */

    return banner_sections;
  }

}

